import styled from 'styled-components'

export const SearchAutocompleteNoResultsUi = styled.div`
  padding: 20px;
`
